import { Button, Col, Input, Row } from 'reactstrap'
import styles from './AddNewVoucher.module.scss'
import { useState } from 'react'
import Multiselect from '../../../../../components/common/MultiselectDropdown/Multiselect'
import SelectCustomersModal from './SelectCustomersModal/SelectCustomersModal'
import SelectProductsModal from './SelectProductsModal/SelectProductsModal'
import ProductSelection from './ProductSelection/ProductSelection'
import AddedCustomers from './AddedCustomers/AddedCustomers'

const AddNewVoucher = () => {

    const [isSelectCustomersModalOpen, setIsSelectCustomersModalOpen] = useState(false)
    const [isSelectProductsModalOpen, setIsSelectProductsModalOpen] = useState(false)
    const [showSelectedCustomers, setShowSelectedCustomers] = useState(false)

    return (
        <div>
            <div>
                <div className={styles['heading']}>General Information</div>
                <div className='p-2 bg-white'>

                    <div className={styles['wrapper']}>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                                Voucher Name
                            </Col>
                            <Col xs='12' lg='4'>
                                <Input placeholder='Enter name of the voucher' />
                            </Col>
                        </Row>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                                Voucher Code:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Multiselect title="Choose from dropdown menu" options={['Store Credit', 'Product Specific']} />
                            </Col>
                        </Row>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                                Voucher Type:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Multiselect title="Choose from dropdown menu" options={['Percentage off', 'Delivery discount', 'Buy 1 get 1 free']} />
                            </Col>
                        </Row>
                    </div>
                </div>

            </div>

            <div>
                <div className={styles['heading']}>Details</div>
                <div className='p-2 bg-white'>

                    <div className={styles['wrapper']}>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                                Validity Period:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Row className='g-0'>
                                    <Col xs='5'>
                                        <Input type='date' />
                                    </Col>
                                    <Col xs='2' className='d-flex justify-content-center align-items-center fw-bold'>-</Col>
                                    <Col xs='5'>
                                        <Input type='date' />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                                Distribution method:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Multiselect title="Choose from dropdown" options={['SMS', "Email"]} />

                            </Col>
                        </Row>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                                Monetary Value:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Multiselect title="Choose from dropdown" options={['Store page', 'Product detail page']} />
                            </Col>
                        </Row>
                    </div>
                </div>

            </div>

            <div>
                <div className={styles['heading']}>Conditions</div>
                <div className='p-2 bg-white'>

                    <div className={styles['wrapper']}>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                                Minimum Purchase Value:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Input placeholder='Enter name of the product' />
                            </Col>
                        </Row>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                                Apply to:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Multiselect title="Choose from dropdown" options={['General use/Specific products']} />
                            </Col>
                        </Row>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                                Target Customer:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Multiselect title="Choose from dropdown" options={['New customers', 'Frequent buyers', 'Individual customers']} />
                            </Col>
                        </Row>
                        {showSelectedCustomers && (
                            <AddedCustomers />
                        )}
                    </div>
                </div>

            </div>

            {/*  Product selection  */}
            <ProductSelection />

            <div>
                <div className={styles['heading']}>Customization</div>
                <div className='p-2 bg-white'>

                    <div className={styles['wrapper']}>
                        <Row className='g-0'>
                            <Col xs='12' lg='2'>
                                Personalized Message:
                            </Col>
                            <Col xs='12'>
                                <Input type='textarea' placeholder='Can add up to 250 words' />
                            </Col>
                        </Row>
                    </div>
                </div>

            </div>


            <div className='d-flex justify-content-center'>
                <div className={styles.BtnContainer}>

                    <div className={styles['btn']}>
                        Cancel
                    </div>

                    <Button type="button" color="primary" className={styles.Btn} onClick={() => { }}>
                        Send Voucher
                    </Button>
                </div>
            </div>
            <SelectCustomersModal isModalOpen={isSelectCustomersModalOpen} setIsModalOpen={setIsSelectCustomersModalOpen} />
            <SelectProductsModal isModalOpen={isSelectProductsModalOpen} setIsModalOpen={setIsSelectProductsModalOpen} />
        </div>
    )
}

export default AddNewVoucher